import { render, staticRenderFns } from "./KPIModule.vue?vue&type=template&id=2a1b8806&scoped=true"
import script from "./KPIModule.vue?vue&type=script&lang=js"
export * from "./KPIModule.vue?vue&type=script&lang=js"
import style0 from "./KPIModule.vue?vue&type=style&index=0&id=2a1b8806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b8806",
  null
  
)

export default component.exports